/** z-index au-dessus de la navbar (100) et du contenu page (carrousels, etc.) */
const PANEL_Z_INDEX = 110;
const PANEL_MIN_WIDTH = 420;
const PANEL_MAX_WIDTH = 560;
const PANEL_GAP = 4;
const VIEWPORT_PADDING = 16;

/**
 * Positionne le panneau Autocomplete sous la navbar, centré sur le champ.
 * Utilise position:fixed + !important pour prendre le pas sur le placement Algolia.
 */
export function syncSearchPanelPosition(container, navRef, panelEl) {
  const panel = panelEl ?? container.querySelector('.kilim-aa-panel');
  const inputEl = container.querySelector('.aa-Input');
  if (!panel || !inputEl) return null;

  const inputRect = inputEl.getBoundingClientRect();
  const panelWidth = Math.min(
    PANEL_MAX_WIDTH,
    Math.max(PANEL_MIN_WIDTH, inputRect.width + 96),
  );
  const idealLeft = inputRect.left + inputRect.width / 2 - panelWidth / 2;
  const maxLeft = window.innerWidth - panelWidth - VIEWPORT_PADDING;
  const left = Math.max(VIEWPORT_PADDING, Math.min(idealLeft, maxLeft));
  /** Collé sous le champ de recherche, pas sous toute la navbar */
  const top = inputRect.bottom + PANEL_GAP;
  const maxHeight = Math.max(220, window.innerHeight - top - VIEWPORT_PADDING);

  panel.style.setProperty('position', 'fixed', 'important');
  panel.style.setProperty('top', `${top}px`, 'important');
  panel.style.setProperty('left', `${left}px`, 'important');
  panel.style.setProperty('width', `${panelWidth}px`, 'important');
  panel.style.setProperty('max-width', 'none', 'important');
  panel.style.setProperty('right', 'auto', 'important');
  panel.style.setProperty('max-height', `${maxHeight}px`, 'important');
  panel.style.setProperty('z-index', String(PANEL_Z_INDEX), 'important');
  panel.style.setProperty('margin', '0', 'important');
  panel.style.setProperty('pointer-events', 'auto', 'important');

  return { top };
}
